<template>
  <Light class="light--blue" :style="{ 'background-color': backgroundColor }"/>
</template>

<script>
  import Light from './Light';
  import {convertBrightness} from '../../utils';

  export default {
    name: 'BlueLight',
    components: {
      Light
    },
    props: [
      'brightness'
    ],
    computed: {
      backgroundColor() {
        return `rgba(0, 0, 255, ${convertBrightness(this.brightness)})`;
      }
    }
  };
</script>

<style>
  .light--blue {
    border-color: blue;
  }
</style>
